<template>
  <div v-if="isHeaderVisible" class="panel-heading collapsible" :class="classObject" @click="toggle()">
    <span :class="['material-icons', 'pr-2', collapsed ? 'expand-more' : '']">expand_less</span>
    <span class="panel-title">{{ $i18n.t(group.label || group.name) }}</span>
  </div>
</template>

<script>
import { PATH_SEPARATOR } from '../../../utils'
import UnhandledError from '../../../lib/errors/UnhandledError'

const expressionFields = ['readOnly', 'label', 'hidden', 'collapsed']

/**
 * @class FormSectionStore
 *
 * @description This component renders a Form's group
 */
export default {
  name: 'FormSection',
  props: {
    path: {
      type: String,
    },
  },
  data() {
    return {
      expressionMap: {
        readOnlyExp: 'readOnly',
        hiddenExp: 'hidden',
        labelExp: 'label',
        collapsedExp: 'collapsed',
      },
    }
  },
  computed: {
    pid() {
      return this.path.split(PATH_SEPARATOR)[0]
    },
    gid() {
      return this.path.split(PATH_SEPARATOR)[1]
    },
    collapsedDefaultClose() {
      return this.$get('collapsedDefaultClose')
    },
    groupAutoCollapse() {
      return this.$get('groupAutoCollapse')
    },
    form() {
      return this.$get('form')
    },
    id() {
      return this.group.id
    },
    isHeaderVisible() {
      return !this.hidden && this.pageGroups.filter((group) => !group.hidden).length > 1 && !this.group.invisibleBorder
    },
    pageGroups() {
      return this.$get('groupsByPageIndex')(this.pid)
    },
    group() {
      return this.$get('groupByPath')(this.path)
    },
    hidden: {
      get() {
        return this.group.hidden
      },
      set(value) {
        this.$commit('FORM_UPDATE_GROUP_VALUE', {
          path: this.path,
          key: 'hidden',
          value,
        })
      },
    },
    label: {
      get() {
        return this.group.label
      },
      set(value) {
        this.$commit('FORM_UPDATE_GROUP_VALUE', {
          path: this.path,
          key: 'label',
          value,
        })
      },
    },
    readOnly: {
      get() {
        return this.form.readOnly || this.group.readOnly
      },
      set(value) {
        this.$commit('FORM_UPDATE_GROUP_VALUE', {
          path: this.path,
          key: 'readOnly',
          value,
        })
      },
    },
    collapsed: {
      get() {
        return this.group.collapsed
      },
      set(value) {
        this.$commit('FORM_UPDATE_GROUP_VALUE', {
          path: this.path,
          key: 'collapsed',
          value,
        })
      },
    },
    classObject() {
      return {
        'hidden-section': this.hidden,
        'collapse-open': this.collapsed,
        'collapse-close': !this.collapsed,
        'read-only': this.readOnly,
        'empty-title': !this.group.label && !this.group.name,
      }
    },
  },
  mounted() {
    if (this.groupAutoCollapse || this.collapsedDefaultClose) {
      this.collapsed = this.gid !== 0
    }
  },
  methods: {
    /**
     * @description Összecsukja, vagy kinyitja a form-groupokat
     */
    toggle() {
      this.collapsed = !this.collapsed
      if (this.groupAutoCollapse) this.accordionClick()
    },
    /**
     * @description Bezárja az összes groupot, és kinyitja azt, amelyikre kattintott a felhasználó
     */
    accordionClick() {
      let groupCount = 0
      try {
        groupCount = this.pageGroups.length
      } catch (error) {
        throw new UnhandledError('Group does not exist on the form', { path: this.path }, error)
      }
      if (groupCount > 1) {
        for (let i = 0; i < groupCount; i++) {
          if (i !== this.gid) {
            this.collapsed = true
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.panel-heading {
  width: 100%;
  display: flex;
  align-items: center;
  background: $color-primary-alpha-50;
  color: $color-text-secondary;
  padding: 10px;
  margin-top: 20px;
  .material-icons {
    transition: 0.5s all;
    color: $color-text-secondary;
    cursor: pointer;
    &.expand-more {
      transform: rotate(180deg);
    }
  }
}
.hidden-section {
  display: none;
}
.hidden-section ~ div {
  display: none;
}
.read-only ~ div {
  pointer-events: auto;
}
</style>
